import type { LetterAvg } from "~/types";

export default async function () {
  const store = useState<LetterAvg>("letterAvg", () => ({
    total: 0,
    avg: {
      enq_1: 0,
      enq_2: 0,
      enq_5: 0,
    },
  }));

  if (store.value.total === 0) {
    const res = await useFetch(() => "/api/review/avg");
    if (res && res.data && res.data.value) {
      store.value = res.data.value;
    }
  }

  return store;
}
